import React, { Component } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Consumer } from "../context";

export default class Modal extends Component {
    render() {
        return (
            <Consumer>
                {value => {
                    const { modalOpen, closeModal } = value;
                    const { img, title, price } = value.modalProduct;
                    if (!modalOpen) {
                        return null;
                    } else {
                        return (
                            <ModalContainer>
                                <div className="container">
                                    <div className="row">
                                        <div
                                            id="modal"
                                            className="col-8 mx-auto col-md-6 col-log-4 text-center text-capitalize p-5"
                                        >
                                            <h5>Item added to to Cart</h5>
                                            <img
                                                src={img}
                                                alt={title}
                                                className="img-fluid"
                                            />
                                            <h5>{title}</h5>
                                            <h5 className="text-muted">
                                                Price: $ {price}
                                            </h5>
                                            <Link to="/">
                                                <button
                                                    className="btn btn-info m-2"
                                                    onClick={closeModal}
                                                >
                                                    Store
                                                </button>
                                            </Link>
                                            <Link to="/cart">
                                                <button
                                                    className="btn btn-success"
                                                    onClick={closeModal}
                                                >
                                                    Go To Cart
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </ModalContainer>
                        );
                    }
                }}
            </Consumer>
        );
    }
}

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;

    #modal {
        background: var(--mainWhite);
    }
`;
